import Vue from 'vue'
import Router from 'vue-router'
const login = () => import('@/views/login/login')
const Home = () => import('@/views/home/Home')
// const HomePage = () => import('@/views/homePage/homePage')
// const OrderManagement = () => import('@/views/orderManagement/orderManagement')
// const PaymentManagement = () => import('@/views/paymentManagement/paymentManagement')
// const ApplicationManagement = () => import('@/views/applicationManagement/applicationManagement')
const UserAccount = () => import('@/views/userManagement/userAccount')
// const MemberManagement = () => import('@/views/userManagement/memberManagement')
const CheckApplet = () => import('@/views/userManagement/checkApplet')
// const MessagePush = () => import('@/views/messageManagement/messagePush')
const CustomerServiceStatistics = () => import('@/views/messageManagement/customerServiceStatistics')
const HistoricalOrder = () => import('@/views/messageManagement/historicalOrder')
const QuickReply = () => import('@/views/messageManagement/quickReply')
const CustomerService = () => import('@/views/messageManagement/customerService')
const OrderDetails = () => import('@/views/messageManagement/orderDetails')
const Roles = () => import('@/views/authorityManagement/Roles')
const AccountManagement = () => import('@/views/authorityManagement/AccountManagement')
import Cookies from "js-cookie";
Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: login,
      meta: {
        title: '悠学管理控制台'
      }
    },
    {
      path: '/home',
      name: '当前位置',
      component: Home,
      children: [        
        {
          path: '/userAccount',
          name: '用户管理',
          component: r => require.ensure([], () => r(require('@/views/userManagement/index')), 'userManagement'),
          meta: {
            title: '用户管理'
          },
          children: [
            {
              path: '/userAccounts',
              name: '用户账号',
              component:UserAccount,
              meta: {
                title: '用户账号'
              },                           
            },
            {
              path: '/',
              name: '用户账号',
              component:r => require.ensure([], () => r(require('@/views/userManagement/index')), 'userManagement'),
              meta: {
                title: '用户账号'
              },     
              redirect:"/userAccounts" ,        
              children:[{
                path: '/userAccount/checkApplet',
                name: '查看小程序',
                component: CheckApplet,
                meta: {
                  title: '查看小程序'
                }
              }]
            },                                        
          ],
        },
        {
          path: '/messageManagement',
          name: '消息管理',
          component: r => require.ensure([], () => r(require('@/views/messageManagement/index')), 'messageManagement'),
          meta: {
            title: '消息管理'
          },
          children: [                    
            {
              path: '/customerServiceStatistics',
              name: '客服统计',
              component: CustomerServiceStatistics,
              meta: {
                title: '客服统计'
              }
            },
            {
              path: '/historicalOrder',
              name: '历史工单',
              component: r => require.ensure([], () => r(require('@/views/messageManagement/orderDetails')), 'historicalOrder'),
              redirect:"/historicalOrders" , 
              meta: {
                title: '历史工单'
              },
              children:[{
                path: '/historicalOrder/orderDetails',
                name: '工单详情',
                component: OrderDetails,
                meta: {
                  title: '工单详情'
                }
              }]
            },
            {
              path: '/historicalOrders',
              name: '历史工单',
              component: HistoricalOrder,
              meta: {
                title: '历史工单'
              }
            },
            {
              path: '/quickReply',
              name: '快捷回复设置',
              component: QuickReply,
              meta: {
                title: '快捷回复设置'
              }
            },
            {
              path: '/customerService',
              name: '客服管理',
              component: CustomerService,
              meta: {
                title: '客服管理'
              }
            },
          ],
        },  
        {
          path: '/roles',
          name: '权限管理',
          component: r => require.ensure([], () => r(require('@/views/authorityManagement/index')), 'authorityManagement'),
          meta: {
            title: '权限管理'
          },
          children: [
            {
              path: '/',
              name: '角色管理',
              component: Roles,
              meta: {
                title: '角色管理'
              }
            },
            {
              path: '/accountManagement',
              name: '账号管理',
              component: AccountManagement,
              meta: {
                title: '账号管理'
              }
            },
          ],
        },  
        
        //这是第一期没有的
        /*
        {
          path: '/homePage',
          name: '首页',
          component: HomePage,
          meta: {
            title: '首页'
          },
          children: [],
        },
        {
          path: '/paymentManagement',
          name: '支付管理系统',
          component: PaymentManagement,
          meta: {
            title: '支付管理系统'
          },
          children: [],
        },
        {
          path: '/orderManagement',
          name: '订单管理系统',
          component: OrderManagement,
          meta: {
            title: '订单管理系统'
          },
          children: [],
        },
        {
          path: '/applicationManagement ',
          name: '应用管理系统',
          component: ApplicationManagement,
          meta: {
            title: '应用管理系统'
          },
          children: [],
        }
        */
      ]
    },
  ]
})
router.beforeEach((to, from, next) => {   
  if(to.query.token){
    Cookies.set("token", to.query.token || "");
    sessionStorage.setItem('id',to.query.id)
  }
  const token = Cookies.get('token')
  if (token) {
    if (to.path == '/') {
      next('/login')      
    } else {   
      next()
    }
  } else {
    if (to.path == '/login') {
      next()
    } else {
      next('/login')
    }
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js